import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { Badge, Button } from '@mui/material';
import { Show } from '@side/pantry';
import { useRef, useState } from 'react';
import { getDateFilterCount } from './DatesFilter.helpers';
import { DatesFilterDropdown } from './DatesFilterDropdown';
import { useFactsAndFiguresContext } from './FactsAndFiguresContext';

export const DatesFilterContainer = () => {
  const dateButtonRef = useRef<HTMLButtonElement>(null);
  const [isDateFilterOpen, setIsDateFilterOpen] = useState(false);
  const {
    dateRange,
    endDate,
    onChangeDateRange,
    onChangeEndDate,
    onChangeStartDate,
    startDate,
  } = useFactsAndFiguresContext();
  const filterCount = getDateFilterCount({
    dateRange,
    endDate,
    startDate,
  });

  return (
    <>
      <Button
        ref={dateButtonRef}
        color="utility"
        endIcon={isDateFilterOpen ? <ArrowDropUp /> : <ArrowDropDown />}
        variant="contained"
        onClick={() => setIsDateFilterOpen(true)}
      >
        Created
        <Show when={filterCount > 0}>
          <Badge
            badgeContent={filterCount}
            color="secondary"
            variant="inline"
            sx={{ pl: 0.5 }}
          />
        </Show>
      </Button>
      <DatesFilterDropdown
        open={isDateFilterOpen}
        onClose={() => setIsDateFilterOpen(false)}
        anchorEl={dateButtonRef.current}
        selectedDateRange={dateRange}
        endDate={endDate}
        onChangeDateRange={onChangeDateRange}
        onChangeEndDate={onChangeEndDate}
        onChangeStartDate={onChangeStartDate}
        startDate={startDate}
      />
    </>
  );
};
